<a class="d-flex">
  <i class="material-icons ml-auto icon-close-dialog" (click)="close()">close</i>
</a>

<form [formGroup]="downloadTrade">
  <div class="search-form">
    <div class="row">
      <div class="col-6 col-md-2 pr-2 pr-md-4">
        <mat-form-field>
          <input matInput [matDatepicker]="startDate" placeholder="Start" formControlName="startDate" (click)="togglePicker(startDate)" [max]="today" readonly />
          <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
          <mat-datepicker panelClass="greengo" #startDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-6 col-md-2 pl-2 pl-md-4">
        <mat-form-field>
          <input matInput [matDatepicker]="endDate" placeholder="End" formControlName="endDate" (click)="togglePicker(endDate)" [max]="today" readonly />
          <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
          <mat-datepicker panelClass="greengo" #endDate></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="col-12 col-md-2 my-3 my-md-0">
        <mat-form-field>
          <mat-select placeholder="Trade status" formControlName="tradeStatus">
            <mat-option *ngFor="let type of types" [value]="type.id"> {{ type.name }} </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="col-6 col-md-2 offset-md-1 pr-2 pr-md-4">
        <button type="button" class="btn btn-lg btn-block" (click)="getSearchDataTable()" [ngClass]="{
        'btn-inactive': !downloadTrade.valid || startDateCtrl.value > endDateCtrl.value,
        'btn-greengo': downloadTrade.valid && startDateCtrl.value <= endDateCtrl.value
      }" npFocusOutClicked>
          Search
        </button>
      </div>
      <div class="col-6 col-md-2 pl-2 pl-md-4">
        <button type="button" class="btn btn-lg btn-block mr-4" type="button" (click)="exportExcel()" [ngClass]="{
          'btn-inactive': !downloadTrade.valid || startDateCtrl.value > endDateCtrl.value,
          'btn-greengo': downloadTrade.valid && startDateCtrl.value <= endDateCtrl.value
        }" npFocusOutClicked>
          Export to Excel
        </button>
      </div>
    </div>
  </div>
  <div class="table-data">
      <ng-table
      [rows]="rows"
      [columns]="columns"
      (cellDblClicked)="onDblCellClick($event)"
      [maxHeight]="40">
      </ng-table>
  </div>
</form>
